// extracted by mini-css-extract-plugin
export var closeButton = "_o2-2";
export var closeButtonIcon = "_o2-3";
export var lightboxContent = "_o2-1";
export var lightboxOverlay = "_o2-0";